import { Pipe, PipeTransform, TemplateRef } from '@angular/core';
import { TableColumn, TableTemplateContext, TemplatesMap } from '../table.types';

@Pipe({
  name: 'appGetCustomTemplate',
  standalone: true,
})
export class GetCustomTemplatePipe implements PipeTransform {

  public transform(value: TableColumn, customTemplates: TemplatesMap): TemplateRef<TableTemplateContext> | null {
    return value.name ? customTemplates[value.name] : null;
  }

}
